import { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import styled from "styled-components";
import { shippingService } from "../../service/ShippingService";
import colors from "../../theme/color/ColorTheme";
import fontSize from "../../theme/fonts/FontTheme";
import FilledButton from "../button/FilledButton";

const Wrapper = styled.div`
  width: 500px;
  height: 445px;
  box-sizing: border-box;
  background-color: ${colors.backgroundSecondary};
  padding: 50px 40px;
  span {
    font-size: ${fontSize.l};
  }
  @media (max-width: 600px) {
    width: 350px;
  }
`;
const Center = styled.div`
  width: fit-content;
  margin: auto;
`;
const Table = styled.div`
  margin: 40px 0px;
  display: flex;
  flex-direction: column;
  gap: 20px;
`;
const Item = styled.div`
  display: flex;
  justify-content: space-between;
  font-weight: 350;
  padding-bottom: 20px;
  border-bottom: 0.6px solid ${colors.border};
  h3 {
    font-size: ${fontSize.m};
    color: ${colors.textMuted};
  }
  b {
    font-weight: 500;
    font-size: ${fontSize.l};
    color: ${colors.black};
  }
`;

function OrderSummaryCard({ actionOnClick, actionText, cart }) {
  const navigate = useNavigate("/");
  const [shippingFee, setShippingFee] = useState();

  const totalPrice = cart.reduce((totalPrice, cartItem) => {
    return totalPrice + cartItem.price;
  }, 0);

  useEffect(() => {
    const fetchShippingFee = async () => {
      shippingService.getShippingFee(
        (fee) => {
          setShippingFee(fee.shippingFee);
        },
        {
          default: () => {
            setShippingFee(0);
          },
        }
      );
    };
    fetchShippingFee();
  }, []);
  return (
    <Wrapper>
      <span>Order Summary</span>
      <Table>
        <Item>
          <h3>Subtotal</h3>
          <h3>
            <b>Rs.{totalPrice}</b>
          </h3>
        </Item>
        <Item>
          <h3>Shipping</h3>
          <h3>
            <b>Rs.{shippingFee}</b>
          </h3>
        </Item>
        <Item>
          <h3>
            <span>
              <b>Total</b>
            </span>
          </h3>
          <h3>
            <b>Rs.{totalPrice < 1 ? 0 : totalPrice + shippingFee}</b>
          </h3>
        </Item>
      </Table>
      <Center>
        {cart.length > 0 ? (
          <FilledButton text={actionText} onClick={() => actionOnClick()} />
        ) : (
          <>
            <FilledButton
              text={"Cart is empty — start shopping"}
              onClick={() => navigate("/products")}
            />
          </>
        )}
      </Center>
    </Wrapper>
  );
}

export default OrderSummaryCard;
